import { Select } from './Field';

interface FacetSelectProps<T extends string> {
  label: string;
  /** Первый вариант — без условия: «Все жанры», «Любая оценка». */
  allLabel: string;
  value: T | null;
  /** Число у варианта — сколько записей останется, если его выбрать. */
  options: readonly { value: T; label: string; count?: number }[];
  onChange: (value: T | null) => void;
}

/**
 * Одно условие фильтра — выпадающим списком, с числом у каждого варианта.
 *
 * Выпадающий, а не ряд чипов: чипы при пяти-шести вариантах занимали две-три
 * строки, а список — одну, сколько бы вариантов ни было.
 */
export function FacetSelect<T extends string>({
  label,
  allLabel,
  value,
  options,
  onChange,
}: FacetSelectProps<T>) {
  return (
    <Select
      label={label}
      value={value ?? ''}
      onChange={(event) => {
        const next = event.target.value;
        onChange(next === '' ? null : (next as T));
      }}
      options={[
        { value: '', label: allLabel },
        ...options.map((option) => ({
          value: option.value,
          label: option.count === undefined ? option.label : `${option.label} · ${option.count}`,
        })),
      ]}
    />
  );
}
